import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { PopUpFactory } from '../../factories/PopUpFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class PopUp extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new PopUpFactory
    this.pageComponent = true
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes', 'containerClasses']
  }

  elementContents() {
    return ['name', 'openOnLeave', 'timeOut', 'timeOutTime']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'PopUp',
      icon: 'fa-comment-alt',
      variations: this.variationsInfo()
    }
  }
}